import usePermissions from '@/hooks/usePermissions'

const PermissionsController = ({ permission, children }) => {
  
  const hasPermission = usePermissions(permission)

  if (hasPermission) {
    return children
  }

  return null
}

export default PermissionsController
